<template>
  <div class="grey darken-1 empty-layout">
    <router-view />
  </div>
</template>

<script>
import messages from '@/utils/messages'
//импорт кодов из утилс меседжес

export default {
  computed: {
    error() {
      // показывание ошибок. получает доступ до ошибок в геттерах
      return this.$store.getters.error
      //когда что-то меняется в еррорах будет обновляться это компьютед свойство. и когда оно измениться нужно отследить этот момент с помощью вотч где говорим за каким полем надо следить
    }
  },
  watch: {
    error(fbError) {
      console.log(fbError)
      //еррор в формате файербайз еррор
      this.$error(messages[fbError.code] || 'Что-то пошло не так')
      //обащается к совйству $error котрое вызывает сообщение об ошибке и передаем сюда объект меседжес с ключем [fbError.code] и если ничего не найдено  8/18,50
    }
  }
}
</script>
